import { ProductInDetailMapType, ProductInDetailType } from "../interface";
import FileUploadDragAndDrop
    from "../../../../../components/common/fileUpload/fileUploadDragAndDrop/FileUploadDragAndDrop";
import { useUpdateProductDetailImageIn } from "../hooks/useUpdateProductDetailImageIn";
import { useParams } from "react-router-dom";
import { useDeleteProductDetailImageIn } from "../hooks/useDeleteProductDetailImageIn";
import { UseFormRegister, UseFormWatch } from "react-hook-form";
import { useReadProductGroupSelectBoxIn } from "../hooks/useReadProductGroupSelectBoxIn";
import React from "react";
import { useUser } from "../../../../../util/userContext/UserContext";

interface PropsType {
    productDetail: ProductInDetailMapType
    register: UseFormRegister<ProductInDetailType>
    watch: UseFormWatch<ProductInDetailType>
}

export default function Tab1({ productDetail, register, watch }: PropsType) {
    const { id } = useParams()

    const { user } = useUser();
    const { mutate: mutateUpdateProductDetailImageIn } = useUpdateProductDetailImageIn()
    const { mutate: mutateDeleteProductDetailImageIn } = useDeleteProductDetailImageIn()
    const { data: productGroupList } = useReadProductGroupSelectBoxIn() as {
        data: { id: string, name: string }[]
    }

    const imageUpdateCallback = (files: File[]) => {
        const fd = new FormData()

        if (files.length !== 0) {
            fd.append("file", files.at(0) as File)
            fd.append("newErpProductid", id as string)

            mutateUpdateProductDetailImageIn(fd)
        }
    }

    const imageDeleteCallback = () => {
        mutateDeleteProductDetailImageIn({
            erpProductImageId: productDetail.productDetailRes.erpProductImageVO.erpProductImageId,
            newErpProductid: productDetail.productDetailRes.newErpProductid
        })
    }

    return <div className="content_wrap">
        <h5 className="subheading mt-0">품목 상세보기</h5>
        <div className="detail_outer_2">
            <div className="left">
                <table className="table table-bordered my_table table_detail m-0">
                    <tbody>
                        {/*<tr className="h-329px">*/}
                        <tr style={{ height: "454px" }}>
                            <th style={{ width: "33.6%", verticalAlign: "middle" }}>제품 사진</th>
                            <td>
                                {/*<AuthorityChecker authorityNames={['productWriteYn']}>*/}
                                <FileUploadDragAndDrop
                                    addFileCallback={(files: File[]) => imageUpdateCallback(files)}
                                    deleteFileCallback={imageDeleteCallback}
                                    accept={"image/*"}
                                    uploadedFileInfo={productDetail.productDetailRes.erpProductImageVO.erpProductImageId ? productDetail.productDetailRes.erpProductImageVO : null}
                                    disabled={user?.authority.productWriteYn === "N"}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="right">
                <table className="table table-bordered my_table table_detail m-0">
                    <tbody>
                        <tr>
                            <th style={{ width: "33.6%" }}>품목명</th>
                            <td>{productDetail.productDetailRes.newTxtNmItem}</td>
                        </tr>
                        <tr>
                            <th>벤더</th>
                            <td>{productDetail.productDetailRes.vendor}</td>
                        </tr>
                        <tr>
                            <th>카테고리</th>
                            <td>{productDetail.productDetailRes.category}</td>
                        </tr>
                        <tr>
                            <th>규격</th>
                            <td>{productDetail.productDetailRes.newTxtStndItem}</td>
                        </tr>
                        <tr>
                            <th>품목코드</th>
                            <td>{productDetail.productDetailRes.newTxtCdItem}</td>
                        </tr>
                        <tr>
                            <th>대분류</th>
                            <td>{productDetail.productDetailRes.majorCategory}</td>
                        </tr>
                        <tr>
                            <th>중분류</th>
                            <td>{productDetail.productDetailRes.subCategory}</td>
                        </tr>
                        <tr>
                            <th>사업부별 제품군</th>
                            <td className="p-4px">
                                {/*<AuthorityChecker authorityNames={['productWriteYn']}>*/}
                                <select className="form-select"
                                    value={watch("newLProductGroupValue")}
                                    {...register("newLProductGroupValue")}
                                    disabled={user?.authority.productWriteYn === "N"}>
                                    <option value={""}>-</option>
                                    {productGroupList?.map(el => <option value={el.id}>{el.name}</option>)}
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <th>제품 설명</th>
                            <td className="p-4px">
                                {/*<AuthorityChecker authorityNames={['productWriteYn']}>*/}
                                <textarea className="form-control"
                                    rows={4}
                                    value={watch("productExplain")}
                                    {...register("productExplain")}
                                    disabled={user?.authority.productWriteYn === "N"}>
                                </textarea>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
}